"use strict";

exports.__esModule = true;

exports.default = function () {
  return {
    manipulateOptions: function manipulateOptions(opts, parserOpts) {
      parserOpts.plugins.push("trailingFunctionCommas");
    }
  };
};

module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-plugin-syntax-trailing-function-commas/lib/index.js
 ** module id = 515
 ** module chunks = 0
 **/